import { filtersSchema, ordersSchema } from './utils';
import { jObjectLittleSchema } from './objectBase';

import { z } from 'zod';
import { onlyOfficeFileSchema } from './onlyOffice';

export const ACCESS_REQUEST_ACCEPT = 'accept';
export const ACCESS_REQUEST_DENY = 'deny';
export const accessRequestStatusValuesSchema = z.union([
    z.literal(ACCESS_REQUEST_ACCEPT),
    z.literal(ACCESS_REQUEST_DENY),
]);
export type AccessRequestStatusValues = z.infer<typeof accessRequestStatusValuesSchema>;

export const wedocFileAudienceTypeSchema = jObjectLittleSchema;
export type WedocFileAudienceType = z.infer<typeof wedocFileAudienceTypeSchema>;

export const wedocTemplateSchema = z.object({
    color: z.string(),
    description: z.string(),
    extension: z.string(),
    icon: z.string(),
    label: z.string(),
});
export declare type WedocTemplate = z.infer<typeof wedocTemplateSchema>;

export const wedocQueryResultsSchema = z.object({
    page: z.number(),
    cnt: z.number(),
    limit: z.number(),
    data: z.array(onlyOfficeFileSchema),
});
export declare type WedocQueryResults = z.infer<typeof wedocQueryResultsSchema>;

export declare type WedocFileType = z.infer<typeof onlyOfficeFileSchema>;

export const wedocQueryTypeSchema = z.object({
    query: z.string(),
    filters: filtersSchema,
    orders: ordersSchema,
    page: z.number(),
    limit: z.number(),
});
export declare type WedocQueryType = z.infer<typeof wedocQueryTypeSchema>;

export const wedocEmptyTypeSchema = z.object({});
export declare type WedocEmptyType = z.infer<typeof wedocEmptyTypeSchema>;
